/** @graphql cc **/
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ExcerptIncludeTargetPageQuery: GraphQLTaggedNode = graphql`
	query ExcerptIncludeTargetPageQuery($contentTitle: String!, $spaceKey: String!, $type: String!) {
		content(title: $contentTitle, spaceKey: $spaceKey, type: $type) {
			nodes {
				id
				body {
					atlas_doc_format {
						value
					}
				}
			}
		}
	}
`;
